import { ConnectorStore, IConnectorProps, IObject } from 'connect-store';
import * as React from 'react';

export interface IRemove extends React.Attributes, IObject {
  id: any;
  callback: IFunction;
}

export class Remove extends React.Component<IRemove> {

  public render(): JSX.Element | null {
    const { callback, id } = this.props as any;
    const style = {
      marginLeft: 10,
      border: 'none',
      borderBottom: '1px solid #e0e0e0',
    };
    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <p style={{ textAlign: 'center' }}>确定删除{id}</p>
        <button
          onClick={() => {
            callback(id);
          }}
        >确定
        </button>
      </div>
    );
  }
}

export const removeFunction = (callback: IFunction, id: any) => {
  return (
    <Remove id={id} callback={callback}/>
  );
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/views/popUp/Remove.tsx